<template>
  <CommonComment :comments="comments" @create-comment="handleCreateComment" />
</template>

<script lang="ts" setup>
import { TComment, TCommentsResponse, TCreateComment } from "~/features/comment";
import { postCreateComment } from "~/features/post/post.service";
import { typesafeI18n } from "~/locales/i18n-vue";
import { useUserStore } from "~/store";

const isLoading = ref<boolean>(true);
const { LL } = typesafeI18n();
const toast = useToast();
const userStore = useUserStore();
const config = useRuntimeConfig();
const { params } = useRoute();

const comments = reactive<TComment[]>([]);

onMounted(async () => {
  const result: TCommentsResponse = await $fetch(
    `${config.public.apiBase}/api/posts/comments/${params.slug}`
  );
  isLoading.value = false;

  comments.push(...result.data);
});

const handleCreateComment = async (comment: TCreateComment) => {
  const { data: res } = await postCreateComment(comment);
  if (res?.value) {
    comments.push({
      ...(res?.value?.record ?? {}),
      user: {
        avatar: userStore.getAvatarUrl,
        firstName: userStore.firstName,
        lastName: userStore.lastName,
        username: userStore.username,
      },
    });
    toast.add({ title: LL.value.success() });
  }
};
</script>
